import React from 'react'
import Icon from '../Display/Icon'

export default (props) => {
	const { setPage } = props.redux.nav
	return (
		<div className='capps-navbar-tab right' onTouchTap={() => {
			window.history.pushState('', '', '/')
			setPage('')
		}}>
			<div className='capps-navbar-icon'>
				<Icon name='weather-night' color='dark' />
				moon
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/Components/Nav/HomeButton.js